import { render, staticRenderFns } from "./propostasRenovacaoSidebar.vue?vue&type=template&id=c72d196a"
import script from "./propostasRenovacaoSidebar.vue?vue&type=script&lang=js"
export * from "./propostasRenovacaoSidebar.vue?vue&type=script&lang=js"
import style0 from "./propostasRenovacaoSidebar.vue?vue&type=style&index=0&id=c72d196a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports